<div class="backdrop" *ngIf="menuOpen" (click)="closeMenu()"></div>
<div class="menu-popup" [ngStyle]="{ top: '90px' }" *ngIf="menuOpen">
  <app-menu
    [customer]="customer"
    [addTopMargin]="true"
    (menuOpenChange)="menuChange($event)"></app-menu>
</div>
